import React from "react";
import ReactDOM from "react-dom";
import { HashRouter } from "react-router-dom";
import { Provider } from "react-redux";
import { App } from "./App/App";
import store from "./_store/store";
import * as serviceWorker from "./serviceWorker";
import { amplifyConfig } from "./_config/aws";
import packageJson from "../package.json";

amplifyConfig();

// Inject app version as a hidden meta tag (visible in page source inspection only)
const versionMeta = document.createElement("meta");
versionMeta.name = "app-version";
versionMeta.content = packageJson.version;
document.head.appendChild(versionMeta);

ReactDOM.render(
  <Provider store={store}>
    <HashRouter>
      <App />
    </HashRouter>
  </Provider>,
  document.getElementById("root")
);

serviceWorker.unregister();
